import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enable brand hover card on product tiles
 */
export const ENABLE_BRAND_HOVER_CARD_ON_PRODUCT_TILES_250806 =
  'ENABLE_BRAND_HOVER_CARD_ON_PRODUCT_TILES_250806' as SettingConst<
    'ENABLE_BRAND_HOVER_CARD_ON_PRODUCT_TILES_250806',
    boolean,
    'RETAILER'
  >;
